export default class Config {
  static readonly MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1Ijoic2hhcmFmdWRoZWVuIiwiYSI6ImNrNHNsMGpjYTA1dDAzZG93a2tnNzV3cnEifQ.hZ0R4NowNN6YzbhOCZFGQg';
  static GOOGLE_ANALYTICS_ID = 'UA-155985479-1';
  static FACEBOOK_APP_ID = '700072304559554';
  static franchise = 'cadillac';
  static GOOGLE_CLIENT_ID =
    '299150888981-bufrrhdsa13ekqq7vo27m2lv1e2g4e00.apps.googleusercontent.com';
  static WHATSAPP_NO = '9651800044';
}
